module.exports = {
	"id": "VU",
	"name": "Vanuatu",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.006102,
			"13": null,
			"14": 0.054918,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.006102,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.024408,
			"25": 0.006102,
			"26": null,
			"27": 0.048816,
			"28": null,
			"29": null,
			"30": null,
			"31": 0.036612,
			"32": 0.006102,
			"33": 0.012204,
			"34": 0.103734,
			"35": 0.012204,
			"36": null,
			"37": 0.006102,
			"38": 0.012204,
			"39": 0.024408,
			"40": 0.622404,
			"41": 0.006102,
			"42": 0.018306,
			"43": 0.097632,
			"44": 0.042714,
			"45": 0.128142,
			"46": 0.012204,
			"47": 0.097632,
			"48": 0.109836,
			"49": 0.781056,
			"50": 0.018306,
			"51": 0.652914,
			"52": 0.768852,
			"53": 19.807092,
			"54": 5.833512,
			"55": 0.109836,
			"56": 0.024408,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": 0.006102,
			"7": 0.024408,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.036612,
			"12": 0.085428,
			"13": null,
			"14": 0.006102,
			"15": null,
			"16": 0.054918,
			"17": 0.073224,
			"18": 0.018306,
			"19": null,
			"20": null,
			"21": 0.006102,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.067122,
			"30": 0.054918,
			"31": null,
			"32": 0.616302,
			"33": 0.006102,
			"34": 0.158652,
			"35": null,
			"36": 0.006102,
			"37": 0.012204,
			"38": 0.170856,
			"39": 0.140346,
			"40": 0.12204,
			"41": 0.036612,
			"42": 0.012204,
			"43": 0.341712,
			"44": 0.463752,
			"45": 0.146448,
			"46": 0.042714,
			"47": 1.073952,
			"48": 0.604098,
			"49": 9.537426,
			"50": 0.94581,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.006102
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.006102,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.51867,
			"41": 0.03051,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.006102,
			"5": 0.03051,
			"6": 0.036612,
			"7": 0.006102,
			"8": 0.079326,
			"9": 0.12204,
			"10": 0.543078,
			"3.1": null,
			"3.2": null,
			"5.1": 0.024408,
			"6.1": 0.018306,
			"7.1": null,
			"9.1": 0.597996
		},
		"ios_saf": {
			"8": 0,
			"10": 3.22074882015,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0867954538926,
			"8.1-8.4": 0.160350923293,
			"9.0-9.2": 0.0764976881765,
			"9.3": 1.16708011449
		},
		"android": {
			"3": 0,
			"4": 0.128077372093,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0160096715116,
			"4.1": 0.461993377907,
			"4.2-4.3": 1.15498344477,
			"4.4": 2.64845708721,
			"4.4.3-4.4.4": 2.67132804651
		},
		"ie": {
			"6": null,
			"7": 0.018461375,
			"8": 1.089221125,
			"9": 0.436919208333,
			"10": 0.356919916667,
			"11": 6.073792375,
			"5.5": null
		},
		"op_mob": {
			"0": 0.00913741256819,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000253817015783
		},
		"edge": {
			"12": 0.146448,
			"13": 0.683424,
			"14": 0.94581
		},
		"ie_mob": {
			"10": 0.122179183099,
			"11": 0.497443816901
		},
		"bb": {
			"7": 0,
			"10": null
		},
		"samsung": {
			"0": 1.98747
		},
		"and_uc": {
			"0": 0.958662
		},
		"op_mini": {
			"0": 0.123106770416
		},
		"and_chr": {
			"0": 25.106292
		},
		"and_ff": {
			"0": 2.061513
		}
	},
	"total": 98.79678
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/VU.json
 ** module id = 681
 ** module chunks = 0
 **/